import { Refresh } from '@browser/Browser';
import { generateName } from "@common/Common";
import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { guid } from '@common/Guid';
import { ICommandBase } from '@Quest/cqrs';
import { ExportAllActiveProjectPlansCommandV1 } from '@Quest/Portfolios/Domain/commands-core';
import PortfoliosCommands from '@Quest/Portfolios/Domain/commands-vue-component';
import { PortfolioScenarioEditorViewModel } from "@Quest/PortfolioScenarios/Components/PortfolioScenarioEditor";
import PortfolioScenarioEditor from '@Quest/PortfolioScenarios/Components/PortfolioScenarioEditor.vue';
import { ClonePortfolioScenarioCommandV1, ConnectToCorporateScenarioCommandV1, CreatePortfolioScenarioCommandV1, DeletePortfolioScenarioCommandV1, UpdatePortfolioScenarioCommandV1 } from '@Quest/PortfolioScenarios/Domain/commands-core';
import PortfolioScenariosCommands from '@Quest/PortfolioScenarios/Domain/commands-vue-component';
import PortfolioScenariosQueries from '@Quest/PortfolioScenarios/Domain/queries-vue-component';
import { CorporateScenarioReadModel, PortfolioScenarioReadModel, PortfolioScenariosPageReadModel, RedirectionPortfolioScenariosPageReadModel } from '@Quest/PortfolioScenarios/Domain/readmodels';
import moment from "moment";
import Component, { mixins } from 'vue-class-component';

@Component({ components: {  PortfolioNavigation, PortfolioScenarioEditor } })
export default class PortfolioScenariosPage extends mixins(PortfolioScenariosQueries, PortfolioScenariosCommands, PortfoliosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get portfolioId()
    {
        if (!this.rm?.PortfolioId)
        {
            throw new Error('PortfolioId is not defined.');
        }
        return this.rm.PortfolioId;
    }


    rm: PortfolioScenariosPageReadModel | null = null;
    portfolioScenarioEditor: PortfolioScenarioEditorViewModel = new PortfolioScenarioEditorViewModel();

    formatDate(date: Date | null)
    {
        if (date == null) return null;
        return moment(date).format('MMM D, YYYY')
    }

    formatTime(date: Date | null)
    {
        if (date == null) return null;
        return moment(date).format('LT');
    }

    showPortfolioScenarioCreator(cScenarioId: string)
    {
        this.portfolioScenarioEditor.showCreator(this.workspaceId, this.portfolioId, cScenarioId);
    }

    showPortfolioScenarioEditor(pScenario: PortfolioScenarioReadModel)
    {
        this.portfolioScenarioEditor.showEditor(this.workspaceId, this.portfolioId, pScenario.Id);
    }


    handleConnectToCorporateScenarioCommand(pScenario: PortfolioScenarioReadModel, cScenario: CorporateScenarioReadModel)
    {
        this.invokeConnectToCorporateScenarioCommandV1(this.workspaceId, this.portfolioId, pScenario.Id, cScenario.Id);
    }


    handleClonePortfolioScenarioCommand(s: PortfolioScenarioReadModel)
    {
        this.invokeClonePortfolioScenarioCommandV1(this.workspaceId, this.portfolioId, s.Id, guid(), generateName(s.Name));
    }

    handleDeletePortfolioScenarioCommand(scenarioId: string)
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeletePortfolioScenarioCommandV1(this.workspaceId, this.portfolioId, scenarioId);
        }
    }

    handleExportAllActiveProjectPlansCommand()
    {
        this.invokeExportAllActiveProjectPlansCommandV1(this.workspaceId, this.portfolioId);
    }


    mounted()
    {
        document.title = "Portfolio Plans";
        this.runPortfolioScenariosPageQueryV1(this.workspaceId, this.tchProjectId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "RedirectionPortfolioScenariosPageReadModel")
        {
            const rm = model as RedirectionPortfolioScenariosPageReadModel;
            location.href = rm.RedirectionUrl;
        }
        else if (modelName == "PortfolioScenariosPageReadModel")
        {
            this.rm = model as PortfolioScenariosPageReadModel;           
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        if (CreatePortfolioScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (UpdatePortfolioScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (ClonePortfolioScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (DeletePortfolioScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (ConnectToCorporateScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
        if (ExportAllActiveProjectPlansCommandV1.matchType(cmd)) 
        {
            if (result) 
            {
                location.href = result;
            }
        }
    }
}